import TypedApiService from '../../util/TypedApi';
import { Invoice } from '../InvoiceModel';

const API_BASE = '/receipt';

/**
 * Receipt Service
 */
export class ReceiptService {
  /**
   * 請求を受領する
   * @returns 請求モデルの配列
   */
  async receipt(params: { id: number }): Promise<Invoice> {
    // async receipt(id: number): Promise<Invoice> {
    const response = await TypedApiService.post<Invoice>(`${API_BASE}/receipt`, params);
    return response.data;
  }

  /**
   * 請求を却下する
   * @returns
   */
  async reject(params: { id: number }): Promise<Invoice> {
    const response = await TypedApiService.post<Invoice>(`${API_BASE}/reject`, params);
    return response.data;
  }
}
